/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Draggable} from 'react-beautiful-dnd';
import TableBody from "./HelperMethods/TableBody";
import {reArrange, titleArray} from "./HelperMethods/DragAndDropHelper";
import urlHelper from "../../../../../_helpers/url.format.server.helper";
import config from "../../../../../config";
import AxiosClient from "../../../../../_helpers/http.helper";
import Svg from "../../../../widgets/Svg/Svg";
import DropDown from '../../../../widgets/DropDown/DropDown';
import Om3pModalContainer from "../OM3PComponents/OmModalContainer";
import {PERMISSIONS} from "../../../../constants/constants";


export default class  Table extends Component {

    constructor(props) {
        super(props);
        const newTitle = this.getTitleName(this.props.title);
        this.state = {
            titleEdit: false,
            titleValue: newTitle,
            showOm3pModal: false,
            sectionDisplayed: true
        };

        this.updateTableTitle = this.updateTableTitle.bind(this);
        this.handleSectionDisplayed = this.handleSectionDisplayed.bind(this);
    }

    getTitleName = (titleWithIndex) => {
        const title = titleWithIndex.slice(0, -2);
        return title;
    };

    componentDidMount() {

        const getChapterDetails = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.chapter,
            {
                collectionId: this.props.collectionId,
                chapterId: this.props.chapter.chapterId
            }

        );

        AxiosClient.get(getChapterDetails)
            .then((result) => {
                this.setState({sectionDisplayed: result.data.sectionDisplayed});
            });

    }

    updateTableTitle(){

        const payload = {
            "chapterId": this.props.chapter.chapterId,
            "title": this.state.titleValue === '' ? 'Untitled Part' : this.state.titleValue,
            "sectionDisplayed": this.state.sectionDisplayed
        };

        const updateChapterTitleUrl = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.chapter,
            {
                collectionId: this.props.collectionId,
                chapterId: this.props.chapter.chapterId
            }

        );

        AxiosClient.patch(updateChapterTitleUrl, payload).then(()=> {
            this.props.loadCollection(this.props.collectionId);
        });

        if(this.state.titleValue === ''){
            this.setState({titleValue: 'Untitled Part'});
        }

        this.setState({titleEdit:false});
    }

    deletePart = (removeResources) => {

        const deletePartUrl = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.deletePart,
            {
                collectionId: this.props.collectionId,
                chapterId: this.props.chapter.chapterId,
                queryParams:{
                    removeResources: removeResources
                }
            }

        );

        AxiosClient.delete(deletePartUrl)
            .then(() => {
                this.props.loadCollection(this.props.collectionId);
            });

        this.props.freezeUi(true);

    };

    getChapterMenuOptions = () => {
        return (
            {
                toggle: <Svg svgString="delete-18"/>,
                menuAlign: 'right',
                upwards: true,
                align: 'left',
                items: this.props.chapterCount !== 1 ? [
                    <button onClick={() => {
                        this.deletePart(false);
                    }}>Delete This Part</button>,
                    <button onClick={() => {
                        this.deletePart(true);
                    }}>Delete This Part And Content</button>
                ] : [
                    <button onClick={() => {
                        this.deletePart(true);
                    }}>Delete This Part And Content</button>
                ]
            }
        );
    };

    showOm3pModal = () => {

        this.setState({showOm3pModal: true});

    };

    hideOm3pModal = () => {

        this.setState({showOm3pModal: false});

    };

    changeSectionDisplayed = () => {

        const payload = {
            "chapterId": this.props.chapter.chapterId,
            "title": this.state.titleValue,
            "sectionDisplayed": this.state.sectionDisplayed
        };

        const updateSectionDisplayed = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.chapter,
            {
                collectionId: this.props.collectionId,
                chapterId: this.props.chapter.chapterId
            }

        );

        AxiosClient.patch(updateSectionDisplayed, payload);
    };

    handleSectionDisplayed =(e) => {

        this.setState({sectionDisplayed : e.target.checked},
            () => {this.changeSectionDisplayed();}
        );
    };

    render() {
        const { chapter } = this.props;
        const index = this.props.index;
        const chapterResources = this.props.chapterResources;

        return (
            <Draggable
                key={chapter.chapterId && chapter.chapterId}
                draggableId={this.props.title}
                index={index}
                isDragDisabled={this.props.permissions.includes(PERMISSIONS.view_only_table_draggable) ||this.state.showOm3pModal}
            >

                {(provided, snapshot) => (

                    <div className='component-dnd-table'>
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}>

                            <div className="table-row">
                                <div className='section-break'>
                                    <span>Would you like to add the section header as a page divider to your book? </span>
                                    {
                                        this.props.collectionType === 'Digital' ?
                                            <div className="pe-checkbox section-header-input-label">
                                                <input type="checkbox" id="checkboxInput" disabled/>
                                                <label className="checkBoxLabel" htmlFor="checkboxInput">Yes</label>
                                                <span><Svg svgString="check-sm-18"/></span>
                                            </div>
                                            :
                                            <div className="pe-checkbox section-header-input-label">
                                                <input type="checkbox" id={index} onChange={this.handleSectionDisplayed} checked = {this.state.sectionDisplayed} disabled={this.props.permissions.includes(PERMISSIONS.view_only_page_divider)}/>
                                                <label htmlFor={index}>Yes</label>
                                                <span className="section-header-input-box"><Svg svgString="check-sm-18"/></span>
                                            </div>
                                    }

                                </div>
                                <div className="table-header">
                                    <div className='index cell'></div>

                                    <div className="table-col cell" {...provided.dragHandleProps}
                                    >
                                        { !this.props.permissions.includes(PERMISSIONS.view_only_part_title) ? <input value={this.state.titleValue} onBlur={this.updateTableTitle} className="chapter-title"
                                            onChange={(e) => {this.setState({titleValue: e.target.value});}}>
                                        </input> : <input value={this.state.titleValue} className="chapter-title-disabled" disabled/>}
                                    </div>
                                    <div className="table-col cell" {...provided.dragHandleProps}
                                    >
                                        File Name
                                    </div>
                                    <div className="table-col cell" {...provided.dragHandleProps}
                                    >
                                        Author
                                    </div>
                                    <div className="table-col cell" {...provided.dragHandleProps}
                                    >
                                        Identifier Type
                                    </div>
                                    <div className="table-col cell" {...provided.dragHandleProps}
                                    >
                                        ISBN
                                    </div>
                                    <div className="table-col cell" {...provided.dragHandleProps}
                                    >
                                        Price
                                    </div>

                                    <div className="col-icons cell"
                                    >
                                        <div className='edit-icons'>
                                            {this.props.chapter.resourceData.length > 0 && !this.props.permissions.includes(PERMISSIONS.view_only_delete_part) ? <DropDown {...this.getChapterMenuOptions()} className="part-drop-down"></DropDown> : <span><Svg svgString={'delete-18'} style={{fill: 'lightGrey'}}></Svg></span>}
                                        </div>
                                    </div>

                                </div>

                                <TableBody
                                    resources={this.props.chapter}
                                    chapterId={this.props.chapter.chapterId}
                                    listId={this.props.title}
                                    resourcesData = {chapterResources}
                                    collectionId = {this.props.collectionId}
                                    loadCollection = {this.props.loadCollection}
                                    activeCollection = {this.props.activeCollection}
                                    freezeUi = {this.props.freezeUi}
                                    permissions = {this.props.permissions}
                                />

                                <div className='ancorDiv link-style'>
                                    {!this.props.permissions.includes(PERMISSIONS.hide_add_content) && <a className="ancorStyle" onClick={()=> {this.props.showAddContentComponent(this.props.chapter.chapterId,this.props.chapter); } }> + Add Content </a>}

                                    {!this.props.permissions.includes(PERMISSIONS.hide_add_om) && <a className="ancorStyle" onClick={this.showOm3pModal}> + Add OM</a>}

                                    {
                                        this.state.showOm3pModal && <Om3pModalContainer
                                            showModal={this.state.showOm3pModal}
                                            onCancel={this.hideOm3pModal}
                                            activeCollection = {this.props.activeCollection}
                                            chapterId={this.props.chapter.chapterId}
                                            loadCollection = {this.props.loadCollection}
                                        />
                                    }
                                </div>

                            </div>

                        </div>
                    </div>
                )}

            </Draggable>

        );
    }

}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterComponents/Table.js